/* eslint-disable */
/**
 * Creates an injectable function that will create the approriately shapes `ActionSuccess<T>`
 * @param {Store} store The state management `store`
 * @returns {FromPayload} The `dispatch` aware injectable
 */
const createFromPayload = ({ dispatch }) => (payload, meta, FROM_PAYLOAD) => {
  return dispatch({
    complete: true,
    error: null,
    meta,
    payload,
    type: FROM_PAYLOAD,
  });
};

export default createFromPayload;
